import React, { useState } from 'react';
import { Box, TextField, Button, Typography } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';

export default function AddIntervalForm({ onIntervalAdded }) {
  const [clientId, setClientId] = useState('');
  const [filename, setFilename] = useState('');
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const handleAddInterval = () => {
    // Build a new interval object
    const newInterval = {
      client_id: clientId,
      filename,
      start_date: startDate ? dayjs(startDate).format('YYYY-MM-DD') : '',
      end_date: endDate ? dayjs(endDate).format('YYYY-MM-DD') : '',
    };

    onIntervalAdded(newInterval);

    // Reset form
    setClientId('');
    setFilename('');
    setStartDate(null);
    setEndDate(null);
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      gap={2}
      sx={{ mt: 2, mb: 3, p: 2, border: '1px solid #ccc', borderRadius: 2 }}
    >
      <Typography variant="h6">Add New Interval</Typography>

      <TextField
        label="Client ID"
        value={clientId}
        onChange={(e) => setClientId(e.target.value)}
        size="small"
      />
      <TextField
        label="Filename"
        value={filename}
        onChange={(e) => setFilename(e.target.value)}
        size="small"
      />

      <DatePicker
        label="Start Date"
        value={startDate}
        onChange={(newValue) => setStartDate(newValue)}
        format="YYYY-MM-DD"
        slotProps={{ textField: { size: 'small' } }}
      />
      <DatePicker
        label="End Date"
        value={endDate}
        onChange={(newValue) => setEndDate(newValue)}
        format="YYYY-MM-DD"
        slotProps={{ textField: { size: 'small' } }}
      />

      <Button variant="contained" onClick={handleAddInterval}>
        Add Interval
      </Button>
    </Box>
  );
}
